import { ADMIN_PRIMARY_KPI_OPTIONS } from "../../../utils/options";

const VALID_PRIMARY_KPI_VALUES = new Set(
  ADMIN_PRIMARY_KPI_OPTIONS.map(({ value }) => value)
);

export const normalizeHomeMetricsPrimaryKpi = (rawValue) => {
  if (typeof rawValue !== "string" || !rawValue.trim()) {
    return null;
  }

  const trimmed = rawValue.trim();

  return VALID_PRIMARY_KPI_VALUES.has(trimmed) ? trimmed : null;
};

export default normalizeHomeMetricsPrimaryKpi;
